(ns renolit-roofing-service.view.session.register
  (:require [dev.gethop.session.re-frame.cognito.action.register :as cognito.register]
            [malli.core :as m]
            [malli.transform :as mt]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [renolit-roofing-service.layout.form :as layout.form]
            [renolit-roofing-service.layout.form.error :as form.error]
            [renolit-roofing-service.layout.info-bar :as layout.info-bar]
            [renolit-roofing-service.layout.session :as layout.session]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.navigation :as nav]
            [renolit-roofing-service.shared.domain.miscellaneous :as dom.misc]
            [renolit-roofing-service.util :as util]
            [renolit-roofing-service.view :as view]
            [renolit-roofing-service.view.session.code-verify :as session.code-verify]))

(def ^:const view-context
  :register-view)

(def ^:const route-config
  {:name [:register]})

(def ^:const form-schema
  [:map
   [:email
    dom.misc/email-schema]
   [:password
    [:string]]
   [:repeat-password
    [:string]]])

(rf/reg-event-fx
 ::register-success
 (fn [_ _]
   {:dispatch [::nav/push-state (:name session.code-verify/route-config)]}))

(rf/reg-event-fx
 ::register-failure
 (fn [_ [_ reason]]
   {:dispatch-n [[::util/generic-error reason]
                 [::layout.info-bar/add-info-bar {:context view-context
                                                  :disappear-in-ms 5000
                                                  :type :error
                                                  :msg-transl-kw
                                                  (condp = reason
                                                    :username-exists
                                                    (t [:error-msg.username-already-in-use])
                                                    (t [:error-msg.unknown]))}]]}))

(defn- on-form-submit
  [state]
  (let [form-data (m/encode form-schema @state mt/strip-extra-keys-transformer)
        form-errors (form.error/check-errors form-schema form-data)
        credentials {:username (:email form-data) :password (:password form-data)}]
    (cond
      form-errors
      (rf/dispatch [::form.error/register-errors view-context form-errors])

      (not (re-matches #"^(?=.*?[a-z]).{8,}$" (:password form-data)))
      (rf/dispatch [::layout.info-bar/add-info-bar
                    {:context view-context
                     :type :error
                     :disappear-in-ms 50000
                     :msg-transl-kw
                     (t [:error-msg.password-format-incorrect])}])

      (not= (:password form-data) (:repeat-password form-data))
      (rf/dispatch [::layout.info-bar/add-info-bar
                    {:context view-context
                     :type :error
                     :disappear-in-ms 5000
                     :msg-transl-kw
                     (t [:error-msg.password-mismatch])}])

      :else
      (rf/dispatch [::cognito.register/user-register
                    credentials
                    {}
                    {:on-success-evt [::register-success]
                     :on-failure-evt [::register-failure]}]))))

(defn- main
  []
  (let [state (r/atom {})
        password-visible? (r/atom false)
        repeat-password-visible? (r/atom false)]
    (fn []
      [layout.session/layout
       [:<>
        [:div.session_main-description
         [:h3.session_main-description-title
          (t [:page.register/title])]
         [:span.session_main-description-subtitle
          (t [:page.register/subtitle])]]
        [:form.simple-form.register_form
         {:on-submit
          (fn [e]
            (.preventDefault e)
            (on-form-submit state))}
         [layout.form/item
          {:context view-context
           :type :input
           :input-type :email
           :state state
           :path [:email]
           :mandatory? true
           :label-transl-kw :label.email
           :placeholder-transl-kw :placeholder.email
           :schema [:string]}]
         [layout.form/item
          (cond-> {:context view-context
                   :type :input
                   :state state
                   :path [:password]
                   :mandatory? true
                   :css-class-prefix "password_input"
                   :icon-kw (if @password-visible? :eye-slash :eye)
                   :on-icon-click #(swap! password-visible? not)
                   :label-transl-kw :label.password
                   :placeholder-transl-kw :placeholder.password
                   :schema [:string]}
            (not @password-visible?) (assoc :input-type :password))]
         [layout.form/item
          (cond-> {:context view-context
                   :type :input
                   :state state
                   :path [:repeat-password]
                   :mandatory? true
                   :css-class-prefix "password_input"
                   :icon-kw (if @repeat-password-visible? :eye-slash :eye)
                   :on-icon-click #(swap! repeat-password-visible? not)
                   :label-transl-kw :label.confirm-password
                   :placeholder-transl-kw :placeholder.confirm-password
                   :schema [:string]}
            (not @repeat-password-visible?) (assoc :input-type :password))]
         [:div.simple-form__action.register_form-actions
          [:button.btn.btn--primary
           {:type :submit}
           (t [:button.register])]]
         [:div.session_register-link
          (t [:page.register.login-text])
          " "
          [:a
           {:href (nav/href [:login])}
           (t [:page.register.login-link])]]]]])))

(defmethod view/view-display (:name route-config)
  [_]
  [main])
